import(/* webpackMode: "eager" */ "/home/tekspertmail/public_html/src/app/privacy/page.tsx");
